
import PlotModel from '../PlotModel';
import PropertyDescriptor from '../../../designer/utils/PropertyDescriptor';
import TextSettingsProperty from './TextSettingsProperty';

export default class Model extends PlotModel {

    settings = new PropertyDescriptor(new TextSettingsProperty(), "设置", "高级", "propertygrid", "#anticon-profile-setting", {
        gallery: "外观",
        valueTemplate: TextSettingsProperty,
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "PlotTextModel";
    }

    toStyle() {
        return this.settings.toStyle();
    }
}
